module.exports = __webpack_public_path__ + "img/ic_my_devices.69c75693.svg";